package de.oevbs.kunde.kundenportal2.services.contract.lineofbusiness

import de.oevbs.businesspartner.bpcrmservice2.contract.model.lineofbusiness.Accident
import de.oevbs.kunde.kundenportal2.components.collapsible
import de.oevbs.kunde.kundenportal2.components.detailsGrid
import de.oevbs.kunde.kundenportal2.components.detailsGridEntry
import de.oevbs.kunde.kundenportal2.services.contract.detailsSectionBlank
import de.oevbs.kunde.kundenportal2.services.contract.toEuro
import de.oevbs.kunde.kundenportal2.services.contract.toJaNein
import de.oevbs.sfa.data.time.toLocalizedString
import dev.fritz2.core.RenderContext


/**
 * Vertragsdetails der Sparte Unfall
 *
 * @param accident beinhaltet die Sparten spezifischen Informationen
 */
fun RenderContext.contractDetailsAccident(accident: Accident) {
    val risks = accident.risks
    if (risks.isNotEmpty()) {
        detailsSectionBlank("Deklarationen") {
            div("flex flex-col gap-2") {
                risks.forEach { risk ->
                    collapsible {
                        isRead(true)
                        headerLeft {
                            detailsGrid {
                                detailsGridEntry("Versicherte Person", risk.insuredPerson.name)
                                detailsGridEntry("Geburtsdatum", risk.insuredPerson.birthdate?.toLocalizedString())
                                detailsGridEntry("Tarifart", risk.tariffType)
                                detailsGridEntry("Beitrag", risk.rateWithout.toEuro())
                                detailsGridEntry("Gefahrengruppe", risk.hazardGroup)
                            }
                        }
                        content {
                            detailsGrid {
                                detailsGridEntry(
                                    "Produktvariante",
                                    if (risk.isSpecial) "Spezial" else "Basis",
                                    longColumn = true
                                )
                                detailsGridEntry("Invalidität", risk.invaliditySum.toEuro())
                                detailsGridEntry("Progressionsstaffel", risk.progressionScale)
                                detailsGridEntry("Tod", risk.deathSum.toEuro())
                                detailsGridEntry("Spezial", risk.isSpecial.toJaNein())
                                detailsGridEntry("Assitenceleistungen", risk.isAssist.toJaNein())
                                detailsGridEntry("Reha-Management", risk.isReha.toJaNein())
                                detailsGridEntry("Krankenhaustagegeld", risk.hospitalBenefits.toEuro())
                                detailsGridEntry("Genesungsgeld", risk.isRecovery.toJaNein())
                                detailsGridEntry("Bezugsberechtigte Person", risk.insuredPerson.role.value)
                                detailsGridEntry("Rente", risk.accidentPension.toEuro())
                                detailsGridEntry("Kosmetische Operationen", risk.cosmeticOperationsSum.toEuro())
                                detailsGridEntry("Bergungskosten", risk.rescueCosts.toEuro())
                                detailsGridEntry("KIZ", risk.childrenInvalidity.toEuro())
                                detailsGridEntry("Deckungsumfang", risk.coverage)
                                detailsGridEntry("Übergangsleistung", risk.transitionPayment.toEuro())
                                detailsGridEntry("Übergangsleistungsvariante", risk.transitionPaymentType)
                            }
                        }
                    }
                }
            }
        }
    }
}